import { registerEventManagement } from "../services";
import { EventManagement, StateOptions } from "../utils/enums";
import EventBus from "@/app/shared/utils/eventBus";
import { Modal } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { createVNode } from "vue";

const BLOCKING_STATES = [
  StateOptions.Refreshment,
  StateOptions.Services,
  StateOptions.Training,
  StateOptions.Dinner,
  StateOptions.Occupied,
];

const ACTION_EVENTS = [
  // EventManagement.Opened,
  EventManagement.Writing,
  EventManagement.Typifying,
  EventManagement.Resolved,
  EventManagement.Waiting,
];

const EVENTS_VALIDATE_DISCONNECTED = [
  EventManagement.Online,
  EventManagement.Ringing,
  EventManagement.Talking,
  EventManagement.Acw,
  EventManagement.Typifying,
  EventManagement.Refreshment,
  EventManagement.Services,
  EventManagement.Training,
  EventManagement.Disconnected,
  EventManagement.Occupied,
  EventManagement.Opened,
  EventManagement.Writing,
  EventManagement.Resolved,
  EventManagement.Waiting,
  EventManagement.Dinner,
]

// Sirve para validar acciones que no se puedan realizar con estados de refrigerio o servicios
export async function validateActionByState(state: any): Promise<any> {
  console.log("Validating action by state: ", state);
  if (!BLOCKING_STATES.includes(state)) {
    return true;
  }

  return new Promise((resolve) => {
    Modal.confirm({
      title: "Estado pendiente de actualización",
      content:
        "Tu estado actual no se ha actualizado. ¿Deseas actualizarlo a “Disponible” para continuar?",
      icon: createVNode(QuestionCircleOutlined),
      okText: "Actualizar estado",
      centered: true,
      cancelButtonProps: {
        style: {
          display: "none",
        },
      },
      async onOk() {
        EventBus.emit("FORCE_CONNECT_STATE", { refreshGlobalState: true });
        EventBus.emit("CLOSE_MODAL_STATE");
        resolve(false);
      },
    });
  });
}

export async function safeRegisterEventManagement(
  eventManagement: any,
  params: any,
  options = { keepAlive: false },
) {
  let state = params?.state;

  const isActionEventNotDisconnected = EVENTS_VALIDATE_DISCONNECTED.includes(eventManagement);

  if (state === StateOptions.Disconnected && isActionEventNotDisconnected) {
    state = StateOptions.Connected;
    await EventBus.emit("FORCE_CONNECT_STATE");
  }

  const isActionEvent = ACTION_EVENTS.includes(eventManagement);
  if (isActionEvent) {
    await validateActionByState(state);

    if (BLOCKING_STATES.includes(state)) {
      state = StateOptions.Connected;
    }
  }

  return registerEventManagement(
    eventManagement,
    {
      ...params,
      state,
    },
    options,
  );
}